export const Fetching_Product_Details = "Fetching_Product_Details";
export const Fetch_Product_Details = "Fetch_Product_Details";
export const Fetch_Product_Error = "Fetch_Product_Error";
export const UpdateProductOptionDisplayPrice = "Update_Product_Option_Display_Price"
export const Show_Product_Details_Modal = "Show_Product_Details_Modal";
export const Hide_Product_Details_Modal = "Hide_Product_Details_Modal";
export const Set_Product_Id_To_Load = "Set_Product_Id_To_Load";